import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const animateElements = () => {
  gsap.registerPlugin(ScrollTrigger);

  const largeLineElements = document.querySelectorAll(
    '.animation-icon.line.large'
  );
  if (largeLineElements && largeLineElements.length > 0) {
    largeLineElements.forEach((element) => {
      const triggerElement = element.parentElement;
      gsap.fromTo(
        element,
        {
          height: '20%',
        },
        {
          height: '80%',
          ease: 'none',
          scrollTrigger: {
            trigger: triggerElement,
            scrub: 1,
            start: 'top bottom',
            end: 'bottom center',
            // markers: true,
          },
        }
      );
    });
  }

  const largeCircleElements = document.querySelectorAll(
    '.animation-icon.circle.large'
  );
  if (largeCircleElements && largeCircleElements.length > 0) {
    largeCircleElements.forEach((element) => {
      const triggerElement = element.parentElement;
      gsap.fromTo(
        element,
        {
          scale: 0.25,
        },
        {
          scale: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: triggerElement,
            scrub: 1,
            start: 'top bottom',
            end: 'bottom top',
            // markers: true,
          },
        }
      );
    });
  }

  const circleElements = document.querySelectorAll(
    '.animation-icon.circle.small'
  );
  if (circleElements && circleElements.length > 0) {
    circleElements.forEach((element) => {
      const triggerElement = element;

      gsap.fromTo(
        element,
        {
          scale: 0,
        },
        {
          scale: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: triggerElement,
            scrub: 1,
            start: 'top bottom+=10%',
            end: '+=50%',
            // markers: true,
          },
        }
      );
    });
  }

  const lineElements = document.querySelectorAll(
    '.animation-icon.line.horizontal'
  );
  if (lineElements && lineElements.length > 0) {
    lineElements.forEach((element) => {
      const triggerElement = element;
      const direction = element.dataset.transformdirection;

      gsap.fromTo(
        element,
        {
          x: direction === 'left' ? '100%' : '-100%',
        },
        {
          x: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: triggerElement,
            scrub: 1,
            start: 'top bottom+=10%',
            end: '+=50%',
            // markers: true,
          },
        }
      );
    });
  }

  const verticalLineElements = document.querySelectorAll(
    '.animation-icon.line.vertical'
  );
  if (verticalLineElements && verticalLineElements.length > 0) {
    verticalLineElements.forEach((element) => {
      const triggerElement = element;

      gsap.fromTo(
        element,
        {
          height: window.innerWidth >= 768 ? 70 : 50,
        },
        {
          height: 200,
          ease: 'none',
          scrollTrigger: {
            trigger: triggerElement,
            scrub: 1,
            start: 'top bottom-=40%',
            end: '+=50%',
            // markers: true,
          },
        }
      );
    });
  }
};

export default animateElements;
